import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.8 4H22c1.2 0 2-.8 2-2s-.8-2-2-2H2c-.2 0-.6 0-.8.2-.4.2-.8.6-1 1-.2.2-.2.6-.2.8v20c0 1.2.8 2 2 2s2-.8 2-2V6.8l16.6 16.6c.4.4 1 .6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8z"
    }, null, -1)
  ]))]))
}
export default { render: render }